import { type ClientRegistry, selectUsersManagementRegistry } from '../../../../domain'

import { UserManagementUsecase } from '../Base'

export class ClientRegistryUsecase extends UserManagementUsecase {
    protected setRegistry (update: Partial<ClientRegistry>): void {
        this.setUsersManagement({ registry: { ...selectUsersManagementRegistry(this.getState()), ...update } })
    }
}
